import log1 from '../../../assets/log.png'
import log2 from '../../../assets/log2.png'
export default {
  data() {
    return {
      // 系统信息
      systemInfo: {},
      log: '',
      routers: [],
      menuCurrentList: [],
      isCollapse: ''
    }
  },
  created() {
    // 获取系统信息
    this.systemInfo = JSON.parse(this.$store.getters['menu/getSYSTEMINFO'])
    this.menuCurrentList = this.$route.matched
    this.routers = this.$router.options.routes
    console.log(this.routers,"sssssssssssssssss")
    this.isCollapse = this.$store.getters['menu/getIsCollapse']
    // this.log = this.$store.getters['menu/getIsCollapse'] ? log2 : log1
  },
  computed: {
    isFollow() {
      return this.$store.state.menu.isCollapse // 需要监听的数据 (菜单是否收起)
    }
  },
  watch: {
    isFollow(newVal, oldVal) {
      this.isCollapse = newVal
      this.log = newVal ? log2 : log1
    }
  },
  methods: {}
}
